import { useEffect } from "react";
import { Checkbox } from "./_Checkbox";

export function Sugestions({ categories, selectedCategory, setSelectedCategory }) {
    return (
        <div className={`suggestions ${categories.length > 0 ? "ready" : ""}`}>
            <span className="title">{suggestionsTxt}</span>
            <nav className="items">
                {categories.slice(0, 4).map((category) => {
                    return (
                        <label className="item" key={category.term_id}>
                            <Checkbox value={category.term_id} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
                            {category.name}
                        </label>
                    );
                })}
            </nav>
        </div>
    );
}
